(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chitificet"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    class CEOSlider {
      constructor(section) {
        this.section = section;
        this.track = section.querySelector('.slider-track');
        this.slides = section.querySelectorAll('.slider-slide');
        this.prevBtn = section.querySelector('.slider-prev');
        this.nextBtn = section.querySelector('.slider-next');
        this.pagination = section.querySelector('.slider-pagination');

        this.slidesPerViewDesktop = parseInt(section.dataset.sliderVisibleDesktop) || 3;
        this.slidesPerViewTablet = parseInt(section.dataset.sliderVisibleTablet) || 2;
        this.slidesPerViewMobile = parseInt(section.dataset.sliderVisibleMobile) || 1;
        this.spaceBetween = parseInt(section.dataset.sliderSpace) || 20;
        this.autoplay = section.dataset.sliderAutoplay === 'true';
        this.loop = section.dataset.sliderLoop === 'true';
        this.speed = parseInt(section.dataset.sliderSpeed) || 400;
        this.navigation = section.dataset.sliderNavigation === 'true';
        this.paginationEnabled = section.dataset.sliderPagination === 'true';
        this.drag = section.dataset.sliderDrag === 'true';
        this.touch = section.dataset.sliderTouch === 'true';
        this.mousewheel = section.dataset.sliderMousewheel === 'true';

        this.currentIndex = 0;
        this.totalSlides = this.slides.length;
        this.slidesPerView = this.getSlidesPerView();
        this.autoplayTimer = null;
        this.isDragging = false;
        this.startX = 0;
        this.currentX = 0;
        this.initialized = false;

        this.initSlider();

        if (this.autoplay) {
          this.startAutoplay();
        }

        this.resizeHandler = this.handleResize.bind(this);
        window.addEventListener('resize', this.resizeHandler);
      }

      getSlidesPerView() {
        var width = window.innerWidth;
        if (width <= 749) return this.slidesPerViewMobile;
        if (width <= 989) return this.slidesPerViewTablet;
        return this.slidesPerViewDesktop;
      }

      handleResize() {
        var newSlidesPerView = this.getSlidesPerView();
        if (newSlidesPerView !== this.slidesPerView) {
          this.slidesPerView = newSlidesPerView;
          this.updateSlider();
        }
      }

      initSlider() {
        if (!this.track || this.totalSlides === 0) return;

        this.initialized = true;
        this.track.style.setProperty('--slider-visible', this.slidesPerView);
        this.track.style.setProperty('--slider-space', this.spaceBetween + 'px');

        this.updateSlider();

        if (this.navigation && this.prevBtn && this.nextBtn) {
          this.prevBtn.addEventListener('click', this.prev.bind(this));
          this.nextBtn.addEventListener('click', this.next.bind(this));
          this.prevBtn.style.display = 'flex';
          this.nextBtn.style.display = 'flex';
        }

        if (this.paginationEnabled && this.pagination) {
          this.createPagination();
        }

        if (this.drag) {
          this.setupDrag();
        }

        if (this.touch) {
          this.setupTouch();
        }

        if (this.mousewheel) {
          this.setupMouseWheel();
        }
      }

      updateSlider() {
        var maxIndex = Math.max(0, this.totalSlides - this.slidesPerView);
        if (this.currentIndex > maxIndex) {
          this.currentIndex = maxIndex;
        }
        this.goTo(this.currentIndex);
      }

      setupDrag() {
        var self = this;
        var isDragging = false;
        var startX = 0;
        var currentX = 0;

        this.track.addEventListener('mousedown', function(e) {
          if (e.button !== 0) return;
          isDragging = true;
          startX = e.clientX;
          currentX = e.clientX;
          self.track.style.cursor = 'grabbing';
          if (self.autoplay) self.stopAutoplay();
        });

        document.addEventListener('mousemove', function(e) {
          if (!isDragging) return;
          currentX = e.clientX;
          var diff = currentX - startX;
          var slideWidth = self.track.offsetWidth / self.slidesPerView;
          var offset = -(self.currentIndex * slideWidth) + diff;
          self.track.style.transform = 'translateX(' + offset + 'px)';
        });

        document.addEventListener('mouseup', function(e) {
          if (!isDragging) return;
          isDragging = false;
          self.track.style.cursor = 'default';
          var diff = currentX - startX;
          var threshold = 50;
          if (Math.abs(diff) > threshold) {
            if (diff < 0) {
              self.next();
            } else {
              self.prev();
            }
          } else {
            self.goTo(self.currentIndex);
          }
          if (self.autoplay) self.startAutoplay();
        });
      }

      setupTouch() {
        var self = this;
        var isDragging = false;
        var startX = 0;
        var currentX = 0;

        this.track.addEventListener('touchstart', function(e) {
          isDragging = true;
          startX = e.touches[0].clientX;
          currentX = e.touches[0].clientX;
          if (self.autoplay) self.stopAutoplay();
        }, { passive: true });

        this.track.addEventListener('touchmove', function(e) {
          if (!isDragging) return;
          currentX = e.touches[0].clientX;
          var diff = currentX - startX;
          var slideWidth = self.track.offsetWidth / self.slidesPerView;
          var offset = -(self.currentIndex * slideWidth) + diff;
          self.track.style.transform = 'translateX(' + offset + 'px)';
        }, { passive: true });

        this.track.addEventListener('touchend', function(e) {
          if (!isDragging) return;
          isDragging = false;
          var diff = currentX - startX;
          var threshold = 30;
          if (Math.abs(diff) > threshold) {
            if (diff < 0) {
              self.next();
            } else {
              self.prev();
            }
          } else {
            self.goTo(self.currentIndex);
          }
          if (self.autoplay) self.startAutoplay();
        }, { passive: true });
      }

      setupMouseWheel() {
        var self = this;
        var timeout = null;

        this.track.addEventListener('wheel', function(e) {
          e.preventDefault();
          if (timeout) return;

          timeout = setTimeout(function() {
            timeout = null;
          }, 500);

          if (e.deltaY > 0) {
            self.next();
          } else {
            self.prev();
          }
        }, { passive: false });
      }

      createPagination() {
        this.pagination.innerHTML = '';
        var total = this.totalSlides - this.slidesPerView + 1;

        for (var i = 0; i < total; i++) {
          var dot = document.createElement('button');
          dot.className = 'dot' + (i === this.currentIndex ? ' active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          var self = this;
          dot.addEventListener('click', function(index) {
            return function() {
              self.goTo(index);
            };
          }(i));
          this.pagination.appendChild(dot);
        }
      }

      updatePagination() {
        if (!this.pagination) return;
        var dots = this.pagination.querySelectorAll('.dot');
        var total = this.totalSlides - this.slidesPerView + 1;

        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('active', i === this.currentIndex);
        }
      }

      goTo(index) {
        var maxIndex = Math.max(0, this.totalSlides - this.slidesPerView);

        if (this.loop) {
          if (index < 0) index = maxIndex;
          if (index > maxIndex) index = 0;
        } else {
          index = Math.max(0, Math.min(index, maxIndex));
        }

        this.currentIndex = index;
        var slideWidth = this.track.offsetWidth / this.slidesPerView;
        var offset = -(index * slideWidth);
        this.track.style.transform = 'translateX(' + offset + 'px)';

        this.updatePagination();
        this.updateButtons();
      }

      next() {
        this.goTo(this.currentIndex + 1);
      }

      prev() {
        this.goTo(this.currentIndex - 1);
      }

      updateButtons() {
        if (!this.prevBtn || !this.nextBtn) return;

        if (!this.loop) {
          var maxIndex = this.totalSlides - this.slidesPerView;
          this.prevBtn.disabled = this.currentIndex === 0;
          this.nextBtn.disabled = this.currentIndex >= maxIndex;
        } else {
          this.prevBtn.disabled = false;
          this.nextBtn.disabled = false;
        }
      }

      startAutoplay() {
        if (this.autoplayTimer) return;
        var self = this;
        this.autoplayTimer = setInterval(function() {
          self.next();
        }, 4000);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      destroy() {
        window.removeEventListener('resize', this.resizeHandler);
        this.stopAutoplay();
      }
    }

    var sections = document.querySelectorAll('[data-section-type="ceo-recommendation-license-slider"]');
    var instances = [];

    function initSections() {
      for (var i = 0; i < sections.length; i++) {
        var instance = new CEOSlider(sections[i]);
        instances.push(instance);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSections);
    } else {
      initSections();
    }

    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target;
      if (section.dataset.sectionType === 'ceo-recommendation-license-slider') {
        var instance = new CEOSlider(section);
        instances.push(instance);
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target;
      if (section.dataset.sectionType === 'ceo-recommendation-license-slider') {
        for (var i = 0; i < instances.length; i++) {
          if (instances[i].section === section) {
            instances[i].destroy();
            instances.splice(i, 1);
            break;
          }
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initFeaturedProductsSlider() {
    var wrappers = document.querySelectorAll('.fps-wrapper');
    
    wrappers.forEach(function(wrapper) {
      var sectionId = wrapper.dataset.sectionId;
      var isMobile = window.innerWidth <= 767;
      
      // Initialize Desktop Swiper
      if (!isMobile) {
        var desktopContainer = document.getElementById('fps-swiper-desktop-' + sectionId);
        var desktopPrevBtn = document.getElementById('fps-prev-desktop-' + sectionId);
        var desktopNextBtn = document.getElementById('fps-next-desktop-' + sectionId);
        var desktopPaginationEl = document.getElementById('fps-pagination-desktop-' + sectionId);
        
        if (desktopContainer && !desktopContainer.swiper) {
          initSwiperInstance(wrapper, desktopContainer, desktopPrevBtn, desktopNextBtn, desktopPaginationEl, false);
        }
      }
      
      // Initialize Mobile Swiper
      if (isMobile) {
        var mobileContainer = document.getElementById('fps-swiper-mobile-' + sectionId);
        var mobilePrevBtn = document.getElementById('fps-prev-mobile-' + sectionId);
        var mobileNextBtn = document.getElementById('fps-next-mobile-' + sectionId);
        var mobilePaginationEl = document.getElementById('fps-pagination-mobile-' + sectionId);
        
        if (mobileContainer && !mobileContainer.swiper) {
          initSwiperInstance(wrapper, mobileContainer, mobilePrevBtn, mobileNextBtn, mobilePaginationEl, true);
        }
      }
    });
  }

  function initSwiperInstance(wrapper, container, prevBtn, nextBtn, paginationEl, isMobile) {
    // Check if container exists and has slides
    if (!container) return;
    var slides = container.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;
    
    // Get settings from data attributes
    var autoplay = wrapper.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(wrapper.dataset.autoplaySpeed) * 1000 || 5000;
    var loop = wrapper.dataset.loop === 'true';
    var desktop = parseInt(wrapper.dataset.desktop) || 5;
    var tablet = parseInt(wrapper.dataset.tablet) || 3;
    var mobile = parseInt(wrapper.dataset.mobile) || 2;
    var spaceBetween = parseInt(wrapper.dataset.spaceBetween) || 20;
    var showArrows = wrapper.dataset.showArrows === 'true';
    var showPagination = wrapper.dataset.showPagination === 'true';
    var maxProducts = parseInt(wrapper.dataset.maxProducts) || 12;
    
    // Determine slides per view based on screen size
    var slidesPerView = isMobile ? mobile : desktop;
    
    // Swiper configuration - HORIZONTAL
    var swiperConfig = {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      loop: loop && slides.length > slidesPerView,
      speed: 600,
      watchSlidesProgress: true,
      grabCursor: true,
      direction: 'horizontal',
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      breakpoints: {
        480: {
          slidesPerView: mobile,
          spaceBetween: spaceBetween,
        },
        768: {
          slidesPerView: tablet,
          spaceBetween: spaceBetween,
        },
        1025: {
          slidesPerView: desktop,
          spaceBetween: spaceBetween,
        },
      },
    };
    
    // Only add autoplay if there are enough slides
    if (autoplay && slides.length > slidesPerView) {
      swiperConfig.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }
    
    // Add navigation arrows
    if (showArrows && prevBtn && nextBtn) {
      swiperConfig.navigation = {
        prevEl: prevBtn,
        nextEl: nextBtn,
      };
    }
    
    // Add pagination
    if (showPagination && paginationEl) {
      swiperConfig.pagination = {
        el: paginationEl,
        clickable: true,
        dynamicBullets: false,
      };
    }
    
    // Initialize Swiper
    try {
      if (typeof Swiper !== 'undefined') {
        var swiper = new Swiper(container, swiperConfig);
        container.swiper = swiper;
      } else {
        console.warn('Swiper not loaded. Make sure Swiper.js is included in your theme.');
      }
    } catch (error) {
      console.warn('Error initializing Swiper:', error);
    }
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedProductsSlider);
  } else {
    initFeaturedProductsSlider();
  }

  // Initialize on Shopify section load
  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target;
    var wrapper = section.querySelector('.fps-wrapper');
    if (wrapper) {
      setTimeout(initFeaturedProductsSlider, 100);
    }
  });

  // Initialize on Shopify section reorder
  document.addEventListener('shopify:section:reorder', function() {
    setTimeout(initFeaturedProductsSlider, 100);
  });

  // Reinitialize on resize
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Destroy and reinitialize swipers on resize
      var wrappers = document.querySelectorAll('.fps-wrapper');
      wrappers.forEach(function(wrapper) {
        var sectionId = wrapper.dataset.sectionId;
        var desktopContainer = document.getElementById('fps-swiper-desktop-' + sectionId);
        var mobileContainer = document.getElementById('fps-swiper-mobile-' + sectionId);
        
        if (desktopContainer && desktopContainer.swiper) {
          desktopContainer.swiper.destroy(true, true);
          desktopContainer.swiper = null;
        }
        if (mobileContainer && mobileContainer.swiper) {
          mobileContainer.swiper.destroy(true, true);
          mobileContainer.swiper = null;
        }
      });
      setTimeout(initFeaturedProductsSlider, 200);
    }, 300);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our_team"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    class OurTeam {
      constructor(section) {
        this.section = section;
        this.isSlider = section.dataset.slider === 'true';
        this.autoplay = section.dataset.sliderAutoplay === 'true';
        this.loop = section.dataset.sliderLoop === 'true';
        this.speed = parseInt(section.dataset.sliderSpeed) || 400;
        this.autoplaySpeed = parseInt(section.dataset.sliderAutoplaySpeed) || 4000;
        this.pagination = section.dataset.sliderPagination === 'true';
        this.pauseOnHover = section.dataset.sliderPauseHover === 'true';

        this.slidesPerViewDesktop = parseInt(section.dataset.slidesDesktop) || 4;
        this.slidesPerViewTablet = parseInt(section.dataset.slidesTablet) || 3;
        this.slidesPerViewMobile = parseInt(section.dataset.slidesMobile) || 1;

        this.currentIndex = 0;
        this.slides = [];
        this.totalSlides = 0;
        this.slidesPerView = this.getSlidesPerView();
        this.autoplayTimer = null;
        this.isDragging = false;
        this.startX = 0;
        this.currentX = 0;
        this.isMobile = window.innerWidth <= 749;
        this.isTablet = window.innerWidth <= 989 && window.innerWidth > 749;
        this.initialized = false;
        this.grid = null;

        if (this.isSlider) {
          this.initSlider();
        }

        this.resizeHandler = this.handleResize.bind(this);
        window.addEventListener('resize', this.resizeHandler);
      }

      getSlidesPerView() {
        var width = window.innerWidth;
        if (width <= 749) return this.slidesPerViewMobile;
        if (width <= 989) return this.slidesPerViewTablet;
        return this.slidesPerViewDesktop;
      }

      handleResize() {
        var newSlidesPerView = this.getSlidesPerView();

        if (this.isSlider) {
          if (newSlidesPerView !== this.slidesPerView) {
            this.slidesPerView = newSlidesPerView;
            this.destroySlider();
            this.initSlider();
          } else if (!this.initialized && this.isMobile) {
            this.initSlider();
          }
        }

        this.isMobile = window.innerWidth <= 749;
        this.isTablet = window.innerWidth <= 989 && window.innerWidth > 749;
      }

      initSlider() {
        this.grid = this.section.querySelector('.team-grid');
        if (!this.grid || this.initialized) return;

        this.slides = Array.from(this.grid.querySelectorAll('.team-member'));
        this.totalSlides = this.slides.length;

        if (this.totalSlides <= this.slidesPerView) {
          this.initialized = true;
          this.grid.style.display = 'grid';
          this.grid.style.gridTemplateColumns = 'repeat(' + this.slidesPerView + ', 1fr)';
          this.grid.style.flexWrap = '';
          this.grid.style.overflow = '';
          this.grid.style.gap = 'var(--card-gap)';
          this.grid.style.transform = '';
          return;
        }

        this.initialized = true;
        this.grid.style.display = 'flex';
        this.grid.style.flexWrap = 'nowrap';
        this.grid.style.overflow = 'visible';
        this.grid.style.gap = '0';
        this.grid.style.transform = '';
        this.grid.style.touchAction = 'pan-y';

        this.setSlideWidth();
        this.goTo(this.currentIndex);

        this.setupTouchEvents();
        this.setupControls();

        if (this.autoplay) {
          this.startAutoplay();
        }
      }

      setSlideWidth() {
        var perView = this.slidesPerView;
        for (var i = 0; i < this.slides.length; i++) {
          var slide = this.slides[i];
          slide.style.flex = '0 0 ' + (100 / perView) + '%';
          slide.style.maxWidth = (100 / perView) + '%';
          slide.style.padding = '0 10px';
          slide.style.transition = 'transform ' + this.speed + 'ms ease';
        }
      }

      setupTouchEvents() {
        var self = this;

        var startTouch = function(e) {
          if (self.totalSlides <= self.slidesPerView) return;
          self.isDragging = true;
          self.startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
          self.currentX = self.startX;
          if (self.grid) self.grid.style.cursor = 'grabbing';
          if (self.autoplay) self.stopAutoplay();
        };

        var moveTouch = function(e) {
          if (!self.isDragging || self.totalSlides <= self.slidesPerView) return;
          self.currentX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
          var diff = self.currentX - self.startX;
          var gridWidth = self.grid ? self.grid.offsetWidth : 1;
          var offset = -(self.currentIndex * (100 / self.slidesPerView)) + (diff / gridWidth * 100);
          if (self.grid) self.grid.style.transform = 'translateX(' + offset + '%)';
        };

        var endTouch = function(e) {
          if (!self.isDragging || self.totalSlides <= self.slidesPerView) return;
          self.isDragging = false;
          if (self.grid) self.grid.style.cursor = 'default';
          var diff = self.currentX - self.startX;
          var threshold = 30;
          if (Math.abs(diff) > threshold) {
            if (diff < 0) {
              self.next();
            } else {
              self.prev();
            }
          } else {
            self.goTo(self.currentIndex);
          }
          if (self.autoplay) self.startAutoplay();
        };

        // Mouse events
        if (this.grid) {
          this.grid.addEventListener('mousedown', startTouch);
          document.addEventListener('mousemove', moveTouch);
          document.addEventListener('mouseup', endTouch);

          this.grid.addEventListener('mouseleave', function() {
            if (self.isDragging) {
              self.isDragging = false;
              if (self.grid) self.grid.style.cursor = 'default';
              self.goTo(self.currentIndex);
              if (self.autoplay) self.startAutoplay();
            }
          });
        }

        // Touch events
        if (this.grid) {
          this.grid.addEventListener('touchstart', startTouch, { passive: true });
          this.grid.addEventListener('touchmove', moveTouch, { passive: true });
          this.grid.addEventListener('touchend', endTouch, { passive: true });
        }

        if (this.pauseOnHover && this.autoplay && this.grid) {
          this.grid.addEventListener('mouseenter', function() {
            self.stopAutoplay();
          });
          this.grid.addEventListener('mouseleave', function() {
            self.startAutoplay();
          });
        }
      }

      setupControls() {
        if (this.pagination) {
          this.createPagination();
        }
      }

      createPagination() {
        var pagination = this.section.querySelector('.slider-pagination');
        if (!pagination) return;

        pagination.innerHTML = '';
        var total = this.totalSlides - this.slidesPerView + 1;

        if (total <= 0) return;

        for (var i = 0; i < total; i++) {
          var dot = document.createElement('button');
          dot.className = 'dot' + (i === this.currentIndex ? ' active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          var self = this;
          dot.addEventListener('click', function(index) {
            return function() {
              self.goTo(index);
            };
          }(i));
          pagination.appendChild(dot);
        }
      }

      updatePagination() {
        var pagination = this.section.querySelector('.slider-pagination');
        if (!pagination) return;

        var dots = pagination.querySelectorAll('.dot');
        if (!dots.length) return;

        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('active', i === this.currentIndex);
        }
      }

      goTo(index) {
        if (!this.grid) return;
        if (this.totalSlides <= this.slidesPerView) {
          this.grid.style.transform = '';
          return;
        }

        var maxIndex = this.totalSlides - this.slidesPerView;

        if (this.loop) {
          if (index < 0) {
            index = maxIndex;
          } else if (index > maxIndex) {
            index = 0;
          }
        } else {
          index = Math.max(0, Math.min(index, maxIndex));
        }

        this.currentIndex = index;
        var offset = -(index * (100 / this.slidesPerView));
        this.grid.style.transform = 'translateX(' + offset + '%)';
        this.updatePagination();
      }

      next() {
        this.goTo(this.currentIndex + 1);
      }

      prev() {
        this.goTo(this.currentIndex - 1);
      }

      startAutoplay() {
        if (this.autoplayTimer) return;
        if (this.totalSlides <= this.slidesPerView) return;
        var self = this;
        this.autoplayTimer = setInterval(function() {
          self.next();
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      destroySlider() {
        if (!this.grid) return;

        this.stopAutoplay();

        this.grid.style.display = '';
        this.grid.style.flexWrap = '';
        this.grid.style.overflow = '';
        this.grid.style.gap = '';
        this.grid.style.transform = '';
        this.grid.style.cursor = '';
        this.grid.style.touchAction = '';

        for (var i = 0; i < this.slides.length; i++) {
          var slide = this.slides[i];
          slide.style.flex = '';
          slide.style.maxWidth = '';
          slide.style.padding = '';
          slide.style.transition = '';
        }

        this.slides = [];
        this.totalSlides = 0;
        this.currentIndex = 0;
        this.initialized = false;
        this.grid = null;
      }

      destroy() {
        window.removeEventListener('resize', this.resizeHandler);
        this.destroySlider();
      }
    }

    var sections = document.querySelectorAll('[data-section-type="our-team"]');
    var instances = [];

    function initSections() {
      for (var i = 0; i < sections.length; i++) {
        var instance = new OurTeam(sections[i]);
        instances.push(instance);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSections);
    } else {
      initSections();
    }

    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target;
      if (section.dataset.sectionType === 'our-team') {
        var instance = new OurTeam(section);
        instances.push(instance);
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target;
      if (section.dataset.sectionType === 'our-team') {
        for (var i = 0; i < instances.length; i++) {
          if (instances[i].section === section) {
            instances[i].destroy();
            instances.splice(i, 1);
            break;
          }
        }
      }
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prouduct_request"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    class ProductRequestForm {
      constructor(section) {
        this.section = section;
        this.form = section.querySelector('#product-request-form');
        this.submitBtn = this.form ? this.form.querySelector('.btn-submit') : null;
        this.resetBtn = this.form ? this.form.querySelector('.btn-reset') : null;

        this.init();
      }

      init() {
        this.setupValidation();
        this.setupFormSubmit();

        if (this.resetBtn) {
          this.resetBtn.addEventListener('click', this.resetForm.bind(this));
        }
      }

      // ============================================
      // VALIDATION
      // ============================================

      setupValidation() {
        var inputs = this.form.querySelectorAll(
          'input[required], select[required], textarea[required]'
        );

        var self = this;
        inputs.forEach(function(input) {
          input.addEventListener('blur', function() {
            self.validateField(input);
          });

          input.addEventListener('input', function() {
            if (input.classList.contains('error')) {
              self.validateField(input);
            }
          });
        });
      }

      validateField(input) {
        var isValid = input.checkValidity();
        input.classList.toggle('error', !isValid);
        return isValid;
      }

      validateAll() {
        var inputs = this.form.querySelectorAll(
          'input[required], select[required], textarea[required]'
        );

        var isValid = true;
        var self = this;
        inputs.forEach(function(input) {
          if (!self.validateField(input)) {
            isValid = false;
          }
        });

        return isValid;
      }

      // ============================================
      // FORM SUBMIT - NATIVE SHOPIFY
      // ============================================

      setupFormSubmit() {
        if (!this.form) return;

        var self = this;
        this.form.addEventListener('submit', function(e) {
          // Validate before submit
          if (!self.validateAll()) {
            e.preventDefault();
            self.showError('সব আবশ্যকীয় ফিল্ড পূরণ করুন।');
          }
        });

        // Check for success/error after submission
        var successMsg = this.form.querySelector('.form-success');
        var errorMsg = this.form.querySelector('.form-error');
        
        if (successMsg && successMsg.style.display !== 'none') {
          if (this.submitBtn) this.submitBtn.style.display = 'none';
        }
      }

      showError(message) {
        var errorMsg = this.form.querySelector('.form-error');
        if (errorMsg) {
          errorMsg.style.display = 'block';
          var heading = errorMsg.querySelector('h3');
          if (heading) {
            heading.textContent = message || 'কিছু একটা ভুল হয়েছে।';
          }
        }
      }

      resetForm() {
        var formContent = this.form.querySelector('.form-content');
        var successMsg = this.form.querySelector('.form-success');
        var errorMsg = this.form.querySelector('.form-error');
        var nav = this.form.querySelector('.form-navigation');

        if (formContent) formContent.style.display = 'block';
        if (successMsg) successMsg.style.display = 'none';
        if (errorMsg) errorMsg.style.display = 'none';
        if (nav) nav.style.display = 'flex';
        if (this.submitBtn) this.submitBtn.style.display = 'flex';

        // Reset all fields
        var inputs = this.form.querySelectorAll('input, select, textarea');
        inputs.forEach(function(input) {
          if (input.type !== 'submit' && input.type !== 'button' && input.type !== 'file') {
            input.value = '';
            if (input.tagName === 'SELECT') {
              input.selectedIndex = 0;
            }
          }
        });
      }
    }

    var sections = document.querySelectorAll(
      '[data-section-type="product-request-form"]'
    );
    var instances = [];

    function initSections() {
      for (var i = 0; i < sections.length; i++) {
        var instance = new ProductRequestForm(sections[i]);
        instances.push(instance);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSections);
    } else {
      initSections();
    }

    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target;
      if (section.dataset.sectionType === 'product-request-form') {
        var instance = new ProductRequestForm(section);
        instances.push(instance);
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target;
      if (section.dataset.sectionType === 'product-request-form') {
        for (var i = 0; i < instances.length; i++) {
          if (instances[i].section === section) {
            instances[i].destroy();
            instances.splice(i, 1);
            break;
          }
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-vision-mission"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    class CompanyStoryVisionMission {
      constructor(section) {
        this.section = section;
        this.isAccordion = section.dataset.accordion === 'true';
        this.accordionSpeed = parseInt(section.dataset.accordionSpeed) || 300;
        this.accordionMultiple = section.dataset.accordionMultiple === 'true';
        this.defaultOpen = section.dataset.accordionDefault || 'first';
        this.cardWrappers = [];
        this.isMobile = window.innerWidth <= 749;
        this.initialized = false;

        if (this.isAccordion && this.isMobile) {
          this.initAccordion();
        }

        this.resizeHandler = this.handleResize.bind(this);
        window.addEventListener('resize', this.resizeHandler);
      }

      handleResize() {
        const isMobile = window.innerWidth <= 749;

        if (this.isAccordion && isMobile && !this.initialized) {
          this.initAccordion();
        } else if (this.isAccordion && !isMobile && this.initialized) {
          this.destroyAccordion();
        } else if (!this.isAccordion && this.initialized) {
          this.destroyAccordion();
        }

        this.isMobile = isMobile;
      }

      initAccordion() {
        const wrappers = this.section.querySelectorAll('.card-wrapper');
        const grid = this.section.querySelector('.cards-grid');

        if (!grid || this.initialized) return;

        this.initialized = true;
        this.cardWrappers = wrappers;

        if (this.defaultOpen === 'first' && wrappers.length > 0) {
          this.openItem(wrappers[0]);
        }

        wrappers.forEach((wrapper) => {
          const card = wrapper.querySelector('.card');
          if (card) {
            card.addEventListener('click', (e) => {
              if (e.target.closest('a') || e.target.closest('.card-button')) {
                return;
              }
              this.toggleItem(wrapper);
            });

            card.setAttribute('role', 'button');
            card.setAttribute('tabindex', '0');
            card.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.toggleItem(wrapper);
              }
            });
          }
        });
      }

      destroyAccordion() {
        this.cardWrappers.forEach(wrapper => {
          wrapper.classList.remove('active');
          const card = wrapper.querySelector('.card');
          if (card) {
            card.removeAttribute('role');
            card.removeAttribute('tabindex');
          }
        });

        this.cardWrappers = [];
        this.initialized = false;
      }

      toggleItem(wrapper) {
        const isOpen = wrapper.classList.contains('active');

        if (isOpen) {
          this.closeItem(wrapper);
        } else {
          if (!this.accordionMultiple) {
            this.closeAllItems();
          }
          this.openItem(wrapper);
        }
      }

      openItem(wrapper) {
        wrapper.classList.add('active');
        const card = wrapper.querySelector('.card');
        if (card) {
          card.setAttribute('aria-expanded', 'true');
        }
      }

      closeItem(wrapper) {
        wrapper.classList.remove('active');
        const card = wrapper.querySelector('.card');
        if (card) {
          card.setAttribute('aria-expanded', 'false');
        }
      }

      closeAllItems() {
        this.cardWrappers.forEach(wrapper => {
          this.closeItem(wrapper);
        });
      }

      destroy() {
        window.removeEventListener('resize', this.resizeHandler);
        this.destroyAccordion();
      }
    }

    const sections = document.querySelectorAll('[data-section-type="company-story-vision-mission"]');
    const instances = [];

    function initSections() {
      sections.forEach(section => {
        const instance = new CompanyStoryVisionMission(section);
        instances.push(instance);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSections);
    } else {
      initSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (section.dataset.sectionType === 'company-story-vision-mission') {
        const instance = new CompanyStoryVisionMission(section);
        instances.push(instance);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target;
      if (section.dataset.sectionType === 'company-story-vision-mission') {
        const index = instances.findIndex(inst => inst.section === section);
        if (index !== -1) {
          instances[index].destroy();
          instances.splice(index, 1);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
